export default {"src":"/_next/static/media/circleExclamationMarkUiOrangeWithLightBg_40.376ecdf1.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};